import { Component, Inject } from '@angular/core';
import { OfferPromoService } from '../../services/offerpromo.service';
import { OfferPromo } from '../../models/offer-promo.model';
import { PromoDomain } from '../../models/promo-domain.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DEFAULT_SNACKBAR_CONFIG, DialogData } from 'src/app/@shared';
import { IPrintPage } from '../../models/print-page.model';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-page',
  templateUrl: './edit-page.component.html',
  styleUrls: ['./edit-page.component.scss']
})
export class EditPageComponent {

  printPagesList: IPrintPage[] = [];
  PageNumber: string = '';

  constructor(
      private offerpromoService: OfferPromoService<OfferPromo, PromoDomain<OfferPromo>>,
      public dialogRef: MatDialogRef<EditPageComponent>,
      private matSnackBar: MatSnackBar,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.getPrintPageDetailsByEvent();
  }

  getPrintPageDetailsByEvent() {
    this.offerpromoService.GetAllPrintPagesByEventforOffers(this.data.eventId).subscribe((res) => {
      this.printPagesList = res;
    })
  }

  closeDialog(res: boolean = false) {
    this.dialogRef.close(res);
  }

  savePage() {
    let OfferDetails: { Id: any; Label: any; }[] = [];
    this.data.selectedRecordsDetails.forEach((record: any) => {
      OfferDetails.push({
        Id: record.DomainId,
        Label: record.EventOfferType
      })
    })
    let request = {
      PrintPageId: this.PageNumber,
      OfferDetails: OfferDetails
    };
    this.offerpromoService.BulkUpdatePrintPage(request).subscribe({
      next:(res) => {
        this.matSnackBar.open(`Page Number updated for selected Offer/Promo(s)`, 'OK', DEFAULT_SNACKBAR_CONFIG);
        this.closeDialog(res);
      },
      error:(err) => {
        this.matSnackBar.open(`Failed to update Page Number`, 'OK', DEFAULT_SNACKBAR_CONFIG);
        this.closeDialog(false);
      }
    })
  }
}
